export default "__VITE_ASSET__BKQNSTnq__"